'use client';

import { useState } from 'react';
import Conditional from '@next-app/components/Conditional';
import GenericImage from '@next-app/components/elements/GenericImage/GenericImage';
import classes from './shipping-restrictions.module.scss';
import parse from 'html-react-parser';
import { ProductDetailContent } from '@next-app/constants/constants';
import DynamicModal from '@next-app/components/elements/DynamicModal/DynamicModal';
import shipRestrictionImg from '../../../public/assets/images/s8.3-shipping-restrictions.svg';

const ShippingRestrictions = ({
  isShippingRestriction,
  applyMargin,
}: {
  isShippingRestriction: any;
  applyMargin: boolean;
}) => {
  const [showModal, setShowModal] = useState(false);
  return (
    <Conditional if={isShippingRestriction}>
      <div
        data-bs-toggle="modal"
        onClick={() => setShowModal(true)}
        data-bs-target={`#dynamicModalWrapper`}
      >
        <div
          className={`d-flex align-items-center ${classes['pdp-product-description-strict']} ll-link-cursor ${applyMargin ? 'my-ll-3' : ''}`}
        >
          <GenericImage
            src={shipRestrictionImg}
            alt="shipping restriction"
            width={26}
            height={26}
          />
          <div
            className={`ll-fs-12 lh-base ${classes['strict-restriction-wrap']}`}
          >
            {' '}
            {ProductDetailContent.shippingRestriction}
          </div>
          <Conditional if={showModal}>
            <DynamicModal
              modalTitle="Shipping Restrictions"
              modalContentClass={`ll-small`}
              onModalClose={() => setShowModal(false)}
            >
              <div className={`${classes['strict-restriction']}`}>
                {parse(`${ProductDetailContent?.shippingDescription}`)}
              </div>
            </DynamicModal>
          </Conditional>
        </div>
      </div>
    </Conditional>
  );
};

export default ShippingRestrictions;
